import script from "./WeaponsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WeaponsSection.vue?vue&type=script&setup=true&lang=js"

import "./WeaponsSection.vue?vue&type=style&index=0&id=74c51302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c51302"]])

export default __exports__